/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: TwTheme.values.colors.white
  },
  content: {
    paddingHorizontal: 16,
    flex: 1
  },
  titleContainer: {
    ...TwTheme.values.textSizes['2xl'],
    color: TwTheme.values.textColors.secondary,
    marginVertical: TwTheme.values.spaces['4']
  },
  tips: {
    color: TwTheme.values.textColors.secondary,
    ...TwTheme.values.textSizes.sm,
    marginVertical: TwTheme.values.spaces['2']
  },
  pinCode: {
    marginVertical: TwTheme.getSpace(6),
    alignItems: 'center'
  },
  countDownText: {
    color: TwTheme.values.textColors.secondary,
    ...TwTheme.values.textSizes.sm
  }
});
